<app-custom-breadcrumb [crumbs]="breadcrumbs" xmlns="http://www.w3.org/1999/html"></app-custom-breadcrumb>
<div class="flex justify-between my-3">
  <h2>{{ accidentId ? 'Edit Accident Record - ' : 'Add Accident Record' }}{{ accidentId ? accidentData?.refNo : '' }}</h2>
</div>

<section id="vehicleAndBookingDetails">
  <div class="grid md:grid-cols-2 gap-4">
    <nz-card>
      <div>
        <h5 class="text-primary">Vehicle Details</h5>
        <div class="grid grid-cols-2 gap-auto">
          <div>
            <p class="font-normal" style="color: #6d6d6d">Model: </p>
          </div>
          <div>
            <p class="font-medium">{{ fleetData?.vehicleDetails?.vehicleModel }}</p>
          </div>
        </div>
        <div class="grid grid-cols-2 gap-auto">
          <div>
            <p class="font-normal" style="color: #6d6d6d">Registration Number: </p>
          </div>
          <div>
            <p class="font-medium">{{ fleetData?.vehicleDetails?.registrationNumber }}</p>
          </div>
        </div>
      </div>
    </nz-card>
    <nz-card *ngIf="accidentForm?.get('accidentType').value === 'BOOKING' && accidentForm?.get('bookingDetails').value">
      <div>
        <h5 class="text-primary">Booking Details</h5>
        <div class="grid grid-cols-2 gap-auto">
          <div>
            <p class="font-normal" style="color: #6d6d6d">SR Booking Id: </p>
          </div>
          <div>
            <a *ngIf="selectedBooking?.refNo" (click)="goTo('booking')"><p
              class="font-medium">{{ selectedBooking?.refNo }}</p></a>
            <p *ngIf="!selectedBooking?.refNo" class="font-medium">-</p>
          </div>
        </div>
        <div class="grid grid-cols-2 gap-auto" *ngIf="selectedBooking?.customerName">
          <div>
            <p class="font-normal" style="color: #6d6d6d">Customer Name: </p>
          </div>
          <div>
            <a *ngIf="selectedBooking?.customerName" (click)="goTo('customer')"><p
              class="font-medium">{{ selectedBooking?.customerName }}</p></a>
            <p *ngIf="!selectedBooking?.customerName" class="font-medium">-</p>
          </div>
        </div>
        <div class="grid grid-cols-2 gap-auto" *ngIf="selectedBooking?.agentName">
          <div>
            <p class="font-normal" style="color: #6d6d6d">Agent Name: </p>
          </div>
          <div>
            <p class="font-medium">{{ selectedBooking?.agentName ? selectedBooking?.agentName : '-' }}</p>
          </div>
        </div>
        <div class="grid grid-cols-2 gap-auto" *ngIf="selectedBooking?.agentRefNo">
          <div>
            <p class="font-normal" style="color: #6d6d6d">Agent Reference No: </p>
          </div>
          <div>
            <p class="font-medium">{{ selectedBooking?.agentRefNo ? selectedBooking?.agentRefNo : '-' }}</p>
          </div>
        </div>
        <div class="grid grid-cols-2 gap-auto">
          <div>
            <p class="font-normal" style="color: #6d6d6d">Booking Type: </p>
          </div>
          <div>
            <p class="font-medium">{{ selectedBooking?.type ? selectedBooking?.type : '-' }}</p>
          </div>
        </div>
      </div>
    </nz-card>
  </div>
</section>

<section id="bookingDetails" class="mt-8">
  <nz-card class="grid gap-4">
    <div>
      <form nz-form [formGroup]="accidentForm" [nzLayout]="'vertical'">
        <!--        <h5 class="text-primary">Insurance Details</h5>-->
        <div class="grid md:grid-cols-2 lg:grid-cols-4 gap-3">
          <div>
            <nz-form-item>
              <nz-form-label nzRequired>Accident Type</nz-form-label>
              <nz-form-control [nzErrorTip]="accidentTypeError">
                <nz-select class="w-full" formControlName="accidentType" (ngModelChange)="getBookingsByFleet($event)"
                           nzPlaceHolder="Select Type">
                  <nz-option nzValue="BOOKING" nzLabel="During a booking"></nz-option>
                  <nz-option nzValue="NOT_BOOKING" nzLabel="Other"></nz-option>
                </nz-select>
              </nz-form-control>
              <ng-template #accidentTypeError>
                  <span
                    *ngIf="formErrors?.accidentType?.required">Please select type. </span>
              </ng-template>
            </nz-form-item>
          </div>
          <div class="lg:col-span-2" *ngIf="accidentForm.get('accidentType').value === 'BOOKING'"
               formGroupName="bookingDetails">
            <nz-form-item>
              <nz-form-label nzRequired>Booking</nz-form-label>
              <nz-form-control [nzErrorTip]="bookingError">
                <nz-select class="w-full" formControlName="booking" nzShowSearch nzAllowClear
                           (ngModelChange)="setBookingDetails($event)"
                           nzPlaceHolder="Select Booking">
                  <nz-option *ngFor="let op of bookingOptions" nzValue="{{op?._id}}"
                             nzLabel="{{op?.refNo}} | {{op?.customerName ? op?.customerName : ''}}
                             | From {{op.arrivalDate | date: 'yyyy-MM-dd'}} to {{op.departureDate | date: 'yyyy-MM-dd'}}
                             | {{op?.type}}"></nz-option>
                </nz-select>
                <p class="text-sm text-primary" *ngIf="fleetBookingsLoading">Loading...</p>
              </nz-form-control>
              <ng-template #bookingError>
                <span *ngIf="formErrors?.bookingDetails?.booking?.required">Please select the relevant booking</span>
              </ng-template>
            </nz-form-item>
          </div>
          <div class="lg:col-span-2" *ngIf="accidentForm.get('accidentType').value === 'NOT_BOOKING'">
            <nz-form-item>
              <nz-form-label>Reason</nz-form-label>
              <nz-form-control [nzErrorTip]="reasonError">
                <input nz-input type="text" placeholder="Enter Reason" formControlName="reason"/>
              </nz-form-control>
              <ng-template #reasonError>
                <!--                <span *ngIf="formErrors?.bookingDetails?.booking?.required">Please select the relevant booking</span>-->
              </ng-template>
            </nz-form-item>
          </div>
        </div>
      </form>
    </div>
  </nz-card>
</section>

<section id="insuranceDetails" class="mt-8">
  <nz-card class="grid gap-4">
    <div>
      <form nz-form [formGroup]="accidentForm" [nzLayout]="'vertical'">
        <h5 class="text-primary">Insurance Details</h5>
        <div class="grid md:grid-cols-2 lg:grid-cols-4 gap-3">
          <nz-form-item formGroupName="insuranceDetails" class="grid grid-flow-row content-between">
            <label class="flex label-styles">Insurance Company</label>
            <input nz-input type="text" placeholder="Enter Company Name" [(ngModel)]="insuranceCompanyNameAlias"
                   [ngModelOptions]="{standalone: true}"/>
          </nz-form-item>
        </div>
        <div class="grid md:grid-cols-2 lg:grid-cols-4 gap-3">
          <nz-form-item formGroupName="insuranceDetails" class="grid grid-flow-row content-between">
            <nz-form-label>Third Party Vehicle Register Number</nz-form-label>
            <!--            <nz-form-item>-->
            <nz-form-control>
              <input nz-input type="text" placeholder="Enter Number" formControlName="thirdPartyVehicleRegisterNo"/>
            </nz-form-control>
            <!--            </nz-form-item>-->
          </nz-form-item>
          <nz-form-item formGroupName="insuranceDetails" class="grid grid-flow-row content-between">
            <nz-form-label>Third Party Driver Name</nz-form-label>
            <!--            <nz-form-item>-->
            <nz-form-control>
              <input nz-input type="text" placeholder="Enter Name"
                     formControlName="thirdPartyDriverName"/>
            </nz-form-control>
            <!--            </nz-form-item>-->
          </nz-form-item>
          <nz-form-item formGroupName="insuranceDetails" class="grid grid-flow-row content-between">
            <nz-form-label>Third Party Driver Contact Number</nz-form-label>
            <!--            <nz-form-item>-->
            <nz-form-control>
              <input nz-input type="text" placeholder="Enter Contact Number"
                     formControlName="thirdPartyDriverContactNo"/>
            </nz-form-control>
            <!--            </nz-form-item>-->
          </nz-form-item>
        </div>
        <div class="grid md:grid-cols-2 lg:grid-cols-4 gap-3">
          <nz-form-item formGroupName="insuranceDetails" class="grid grid-flow-row content-between">
            <nz-form-label>Third Party Insurance Number</nz-form-label>
            <!--            <nz-form-item>-->
            <nz-form-control>
              <input nz-input type="text" placeholder="Enter Number" formControlName="thirdPartyInsuranceNo"/>
            </nz-form-control>
            <!--            </nz-form-item>-->
          </nz-form-item>
          <nz-form-item formGroupName="insuranceDetails" class="grid grid-flow-row content-between">
            <nz-form-label>Third Party Insurance Expiry Date</nz-form-label>
            <!--            <nz-form-item>-->
            <nz-form-control>
              <nz-date-picker id="thirdPartyInsuranceExpiryDateId" class="w-full"
                              formControlName="thirdPartyInsuranceExpiryDate"
                              nzPlaceHolder="Select Date"></nz-date-picker>
            </nz-form-control>
            <!--            </nz-form-item>-->
          </nz-form-item>
        </div>
      </form>
    </div>
  </nz-card>
</section>

<section id="driverDetails" class="mt-8">
  <nz-card class="grid gap-4">
    <div>
      <form nz-form [formGroup]="accidentForm" [nzLayout]="'vertical'">
        <h5 class="text-primary">Driver Details</h5>

        <div formGroupName="driverDetails" class="grid md:grid-cols-2 gap-3">
          <div class="grid lg:grid-cols-2 gap-3">

            <nz-form-item class="grid grid-flow-row content-between">
              <nz-form-label nzRequired>Driver Name</nz-form-label>
              <nz-form-control [nzErrorTip]="driverNameErrors">
                <input nz-input type="text" placeholder="Enter Name" formControlName="driverName"/>
              </nz-form-control>
              <ng-template #driverNameErrors>
                <span *ngIf="formErrors.driverDetails.driverName.required">Please enter driver name</span>
              </ng-template>
            </nz-form-item>

            <nz-form-item class="grid grid-flow-row content-between">
              <nz-form-label nzRequired>Driver Contact Number</nz-form-label>
              <nz-form-control [nzErrorTip]="driverContactNoErrors">
                <input nz-input type="text" placeholder="Enter Number" formControlName="driverContactNo"/>
              </nz-form-control>
              <ng-template #driverContactNoErrors>
                  <span
                    *ngIf="formErrors.driverDetails.driverContactNo.required">Please enter driver contact number</span>
              </ng-template>
            </nz-form-item>
          </div>

          <!--          To do fill-->
          <!--          <div class="mb-5 md:mb-0">-->
          <!--            <div class="sub-section">-->
          <!--              <div class="grid grid-cols-2 gap-auto">-->
          <!--                <div>-->
          <!--                  <p class="font-normal" style="color: #6d6d6d">Driver's International Licence </p>-->
          <!--                </div>-->
          <!--                <div>-->
          <!--                  <p class="font-medium">FG568459592</p>-->
          <!--                </div>-->
          <!--              </div>-->
          <!--              <div class="grid grid-cols-2 gap-auto">-->
          <!--                <div>-->
          <!--                  <p class="font-normal" style="color: #6d6d6d">Driver's SL Driving Permit Number </p>-->
          <!--                </div>-->
          <!--                <div>-->
          <!--                  <p class="font-medium">SLD3456385</p>-->
          <!--                </div>-->
          <!--              </div>-->
          <!--            </div>-->
          <!--          </div>-->
        </div>

        <div formGroupName="driverDetails" class="grid md:grid-cols-2 gap-3">
          <div>
            <nz-form-item>
              <nz-form-label nzRequired>Driver's Address</nz-form-label>
              <nz-form-control [nzErrorTip]="driverAddressErrors">
                <textarea nz-input placeholder="Enter Address" [nzAutosize]="{ minRows: 3, maxRows: 5 }"
                          formControlName="driverAddress"></textarea>
              </nz-form-control>
              <ng-template #driverAddressErrors>
                <span *ngIf="formErrors.driverDetails.driverAddress.required">Please enter address</span>
              </ng-template>
            </nz-form-item>
          </div>
        </div>

      </form>
    </div>
  </nz-card>
</section>

<section id="accidentDetails" class="mt-8">
  <nz-card class="grid gap-4">
    <div>
      <form nz-form [formGroup]="accidentForm" [nzLayout]="'vertical'">
        <h5 class="text-primary">Accident Details</h5>

        <div formGroupName="accidentDetails" class="grid md:grid-cols-2 gap-3">
          <div class="grid lg:grid-cols-2 gap-3">
            <!--            <div>-->
            <nz-form-item class="grid grid-flow-row content-between">
              <nz-form-label nzRequired>Accident Date and Time</nz-form-label>
              <nz-form-control [nzErrorTip]="accidentDateAndTimeErrors">
                <nz-date-picker
                  placeholder="Enter Date and Time"
                  nzShowTime
                  nzFormat="yyyy-MM-dd HH:mm"
                  formControlName="accidentDateAndTime"
                  class="w-full"></nz-date-picker>
              </nz-form-control>
              <ng-template #accidentDateAndTimeErrors>
                <span *ngIf="formErrors.accidentDetails.accidentDateAndTime.required">Please enter accident date and time</span>
              </ng-template>
            </nz-form-item>
            <!--            </div>-->
            <!--            <div>-->
            <nz-form-item class="grid grid-flow-row content-between">
              <nz-form-label nzRequired>Place of the Accident</nz-form-label>
              <nz-form-control [nzErrorTip]="accidentPlaceErrors">
                <input nz-input type="text" placeholder="Enter the Place" formControlName="placeOfTheAccident"/>
              </nz-form-control>
              <ng-template #accidentPlaceErrors>
                <span
                  *ngIf="formErrors.accidentDetails.placeOfTheAccident.required">Please enter accident date and time</span>
              </ng-template>
            </nz-form-item>
            <!--            </div>-->

            <div>
              <nz-form-label nzRequired>Accident - Notified / Detected</nz-form-label>
              <span class="flex -mt-3" style="color: #ff4d4f!important;"
                    *ngIf="(!detected && !notified && notifiedOrDetectedError)">Please select one of this options</span>
            </div>
            <div class="mb-5 md:mb-0">
              <button nz-button style="border-radius: 0!important;" class="mr-2 lg:mb-2 xl:mb-0"
                      [ngClass]="notified ? 'selected-button' : ''"
                      (click)="setNotifiedOrDetected('notified')">Notified
              </button>
              <button nz-button style="border-radius: 0!important;" [ngClass]="detected ? 'selected-button' : ''"
                      (click)="setNotifiedOrDetected('detected')">
                Detected
              </button>
            </div>

            <div>
              <nz-form-label nzRequired *ngIf="notified">Notified SR User</nz-form-label>
              <nz-form-label nzRequired *ngIf="detected">Detected SR User</nz-form-label>
              <nz-form-item *ngIf="detected || notified">
                <nz-form-control [nzErrorTip]="notifiedOrDetectedErrors">
                  <nz-select class="w-full" formControlName="notifiedOrDetectedUser" nzPlaceHolder="Select User"
                             nzShowSearch nzAllowClear>
                    <nz-option *ngFor="let user of users" nzValue="{{user._id}}" nzLabel="{{user.name}}"></nz-option>
                  </nz-select>
                </nz-form-control>
                <ng-template #notifiedOrDetectedErrors>
                  <span *ngIf="formErrors.accidentDetails.notifiedOrDetectedUser.required">Please select user</span>
                </ng-template>
              </nz-form-item>
            </div>
            <div>

            </div>

            <div>
              <nz-form-label>Insurance Notified</nz-form-label>
            </div>
            <div class="mb-5 md:mb-3">
              <button nz-button style="border-radius: 0!important;" class="mr-2 lg:mb-2 xl:mb-0"
                      [ngClass]="insuranceNotified === 'ON_SITE' ? 'selected-button' : ''"
                      (click)="setInsuranceNotified('ON_SITE')">Onsite
              </button>
              <button nz-button style="border-radius: 0!important;"
                      [ngClass]="insuranceNotified === 'ON_DEPARTURE' ? 'selected-button' : ''"
                      (click)="setInsuranceNotified('ON_DEPARTURE')">On Departure
              </button>
            </div>

            <div *ngIf="insuranceNotified === 'ON_DEPARTURE'">
              <nz-form-label>Need to notify the Insurance</nz-form-label>
            </div>
            <div *ngIf="insuranceNotified === 'ON_DEPARTURE'" class="mb-5 md:mb-3">
              <button nz-button style="border-radius: 0!important;" class="mr-2"
                      [ngClass]="needToNotifyTheInsurance ? 'selected-button' : ''"
                      (click)="setNeedToNotifyInsuranceAndPoliceReportObtained('YES', 'insurance')">Yes
              </button>
              <button nz-button style="border-radius: 0!important;" class="mr-2"
                      [ngClass]="!needToNotifyTheInsurance ? 'selected-button' : ''"
                      (click)="setNeedToNotifyInsuranceAndPoliceReportObtained('NO', 'insurance')">No
              </button>
            </div>

            <div>
              <nz-form-label>Police Report Obtained</nz-form-label>
              <span class="flex -mt-3" style="color: #ff4d4f!important;" *ngIf="policeReportObtainedErrors">Please select Yes or No</span>
            </div>
            <div class="mb-5 md:mb-3">
              <button nz-button style="border-radius: 0!important;" class="mr-2" class="mr-2"
                      [ngClass]="policeReportObtained ? 'selected-button' : ''"
                      (click)="setNeedToNotifyInsuranceAndPoliceReportObtained('YES', 'police')">Yes
              </button>
              <button nz-button style="border-radius: 0!important;"
                      [ngClass]="!policeReportObtained ? 'selected-button' : ''"
                      (click)="setNeedToNotifyInsuranceAndPoliceReportObtained('NO', 'police')">No
              </button>
            </div>
          </div>
        </div>

        <div formGroupName="accidentDetails" class="grid md:grid-cols-2 gap-3">
          <div>
            <nz-form-label>Remarks</nz-form-label>
            <nz-form-item>
              <nz-form-control>
                <textarea class="hidden xl:block" nz-input placeholder="Enter Remarks"
                          [nzAutosize]="{ minRows: 8, maxRows: 8 }"
                          formControlName="remarks"></textarea>
                <textarea class="block xl:hidden" nz-input placeholder="Enter Remarks"
                          [nzAutosize]="{ minRows: 5, maxRows: 5 }"
                          formControlName="remarks"></textarea>
              </nz-form-control>
            </nz-form-item>
          </div>
          <div>
            <div>
              <nz-form-label>Attachments</nz-form-label>

              <div class="flex flex-col items-center justify-center bg-slate-100 w-full h-[8.5rem] xl:h-52 py-2">
                <div>
                  <nz-upload
                    [nzCustomRequest]="attachmentUpload" [nzShowUploadList]="false" [nzMultiple]="true">
                    <button nz-button>
                      <span nz-icon nzType="upload"></span>
                      Click to Upload
                    </button>
                  </nz-upload>
                </div>
                <div>
                  <p *ngIf="attachmentUploading" class="text-primary my-2">Uploading...</p>
                </div>
                <div class="mt-2 overflow-auto">
                  <div *ngFor="let file of attachmentFiles; let i = index"
                       class="flex justify-between items-center mx-3 gap-5">
                    <a target="_blank" href="{{file.url}}">{{ file.name }}</a>
                    <span nz-icon nzType="close-circle" nzTheme="outline" [nzTheme]="'twotone'"
                          [nzTwotoneColor]="'#ff0000'"
                          class="cursor-pointer" nz-popconfirm
                          nzPopconfirmTitle="Are you sure you want to delete this attachment"
                          (nzOnConfirm)="removeAttachment(i)"
                    ></span>
                  </div>
                </div>
              </div>

              <!--              <nz-upload-->
              <!--                [nzCustomRequest]="attachmentUpload" [nzShowUploadList]="false" [nzMultiple]="true"-->
              <!--                class="flex justify-center items-center bg-slate-100 w-full h-40 xl:h-40">-->
              <!--                <button *ngIf="!attachmentUploading" nz-button>-->
              <!--                  <span nz-icon nzType="upload"></span>-->
              <!--                  Click to Upload-->
              <!--                </button>-->
              <!--                <p *ngIf="attachmentUploading" class="text-primary text-lg">Uploading...</p>-->
              <!--              </nz-upload>-->
              <!--              <div *ngFor="let file of attachmentFiles; index as i">-->
              <!--                <div class="flex items-center gap-2">-->
              <!--                  <a target="_blank" href="{{file.url}}">{{file.name}}</a>-->
              <!--                  <span nz-icon nzType="close-circle" nzTheme="outline" class="hover:text-primary hover:cursor-pointer hover:text-md"-->
              <!--                        nz-popconfirm-->
              <!--                        nzPopconfirmTitle="Are you sure you want to delete this attachment?"-->
              <!--                        (nzOnConfirm)="removeAttachment(i)" (nzOnCancel)="cancel()"></span>-->
              <!--                </div>-->
              <!--              </div>-->
            </div>
          </div>
        </div>
      </form>


      <div class="grid lg:grid-cols-2 gap-3 mt-5">
        <form nz-form [formGroup]="accidentForm" [nzLayout]="'horizontal'">
          <div formGroupName="paymentDetails">
            <nz-form-item>
              <nz-form-label class="w-1/2 text-start">Deposit Amount</nz-form-label>
              <nz-form-control>
                <nz-input-number-group nzAddOnAfter="LKR">
                  <nz-input-number formControlName="depositAmount" [nzStep]="1" [nzMin]="0"
                                   [nzFormatter]="formatterDecimal"
                  ></nz-input-number>
                </nz-input-number-group>
              </nz-form-control>
            </nz-form-item>

            <nz-form-item>
              <nz-form-label class="w-1/2 text-start">Damage Charge</nz-form-label>
              <nz-form-control>
                <nz-input-number-group nzAddOnAfter="LKR">
                  <nz-input-number formControlName="damageCharge"
                                   [nzStep]="1"
                                   [nzMin]="0"
                                   [nzPrecision]="2"
                                   [nzFormatter]="formatterDecimal"
                  ></nz-input-number>
                </nz-input-number-group>
              </nz-form-control>
            </nz-form-item>

            <nz-form-item>
              <nz-form-label class="w-1/2 text-start">Loss of Rental Charge</nz-form-label>
              <nz-form-control>
                <!--                <input class="w-auto text-end" nz-input type="number" placeholder="Enter Number"-->
                <!--                       formControlName="lossOfRentalCharge"/>-->
                <nz-input-number-group nzAddOnAfter="LKR">
                  <nz-input-number formControlName="lossOfRentalCharge"
                                   [nzStep]="1"
                                   [nzMin]="0"
                                   [nzPrecision]="2"
                                   [nzFormatter]="formatterDecimal"
                  ></nz-input-number>
                </nz-input-number-group>
              </nz-form-control>
            </nz-form-item>
            <div class="">
              <nz-divider></nz-divider>
            </div>
            <nz-form-item>
              <nz-form-label class="w-1/2 text-start">Total Charge</nz-form-label>
              <nz-form-control>
                <!--                <input class="w-auto text-end" nz-input type="number" placeholder="Enter Amount"-->
                <!--                       formControlName="totalCharge"/>-->
                <nz-input-number-group nzAddOnAfter="LKR">
                  <nz-input-number formControlName="totalCharge"
                                   [nzStep]="1"
                                   [nzMin]="0"
                                   [nzPrecision]="2"
                                   [nzFormatter]="formatterDecimal"
                  ></nz-input-number>
                </nz-input-number-group>
              </nz-form-control>
            </nz-form-item>
          </div>
        </form>
      </div>
    </div>
  </nz-card>
</section>


<section id="damages" class="mt-8">
  <nz-card>
    <div>
      <div class="flex gap-1">
        <span class="text-red-500">*</span>
        <h5 class="text-primary">Damages</h5>
      </div>
      <div class="mt-5 grid md:grid-cols-1 xl:grid-cols-2 gap-8">
        <div>
          <div class="md:col-span-2 p-6">
            <nz-alert nzType="info" nzMessage="Select the damaged area on the image below to add a new record"
                      class="mb-3" nzShowIcon></nz-alert>
          </div>

          <div class="image-container cursor-crosshair" (click)="showModal($event)">
            <img style="max-width: 100%;height: auto;" src="assets/img/car-damage.png" alt="Image" #image>
            <div *ngFor="let marker of markers">
              <div *ngIf="marker?.status !== false" class="marker"
                   [style.left.%]="marker.x" [style.top.%]="marker.y">
                {{ marker.number }}
              </div>
              <div style="background-color: green" *ngIf="marker.status === false" class="marker"
                   [style.left.%]="marker.x" [style.top.%]="marker.y">
                {{ marker.number }}
              </div>
            </div>
          </div>
        </div>

        <div class="sub-section">


          <nz-collapse>
            <nz-collapse-panel
              *ngFor="let panel of this.markers; let i = index"
              [nzHeader]='panelHead'
              style="background-color: white; border: 2px solid #d9d9d9;" class="font-medium"
            >

              <div class="damage-card mb-3 my-2 flex flex-col sm:flex-row">


                <div class="w-full p-5">
                  <div class="pl-0 sm:pl-2">
                    <div class="flex justify-between mb-2">
                      <div>
                        <p style="font-weight: 400; color: #6d6d6d">Damage Type: </p>
                        <p class="subject-data">{{ panel.damageType }}</p>
                      </div>
                      <!--                      <div class="flex-grow">-->

                      <!--                      </div>-->
                      <div class="badge-Id">
                        <span class="badge-number" *ngIf="panel.damageType === 'Scratch'">1</span>
                        <span class="badge-number" *ngIf="panel.damageType === 'Dent'">2</span>
                        <span class="badge-number" *ngIf="panel.damageType === 'Broken'">3</span>
                        <span class="badge-number" *ngIf="panel.damageType === 'Cracked'">4</span>
                        <span class="badge-number" *ngIf="panel.damageType === 'Missing'">5</span>
                        <span class="badge-number" *ngIf="panel.damageType === 'Stain'">6</span>
                        <span class="badge-number" *ngIf="panel.damageType === 'Smashed'">7</span>
                      </div>
                    </div>

                    <div class="mb-2">
                      <p class="subject-name">Description: </p>
                      <p class="subject-data">{{ panel.description }}</p>
                    </div>

                    <div class="mb-2">
                      <p class="subject-name">Attachments: </p>
                      <div class="mt-3 flex" style="flex-wrap: wrap;">
                        <img *ngFor="let attachment of panel.files" style="margin-left: 3px; margin-bottom: 3px"
                             [src]="attachment.url"
                             height="80" width="160" alt="Image">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="">
                <nz-divider></nz-divider>
              </div>

              <ng-template #panelHead>
                <div class="flex" style="margin-right: 20px">
                  <div class="badge" *ngIf="panel?.status !== false">
                    <span class="badge-number">{{ panel.number }}</span>
                  </div>
                  <div class="badge" style="background-color: green" *ngIf="panel.status === false">
                    <span class="badge-number">{{ panel.number }}</span>
                  </div>
                </div>
                <p class="font-semibold">{{ panel.damageType }}</p>
                <div class="flex-grow"></div><!-- This div will push the button to the right -->

                <!--                <div class="">-->
                <!--                  <button-->
                <!--                    class="mx-2"-->
                <!--                    nz-button-->
                <!--                    nzType="text"-->
                <!--                    (click)="editDamage(panel, i)"-->
                <!--                  >-->
                <!--                    <span nz-icon nzType="edit" nzTheme="outline"></span>-->
                <!--                  </button>-->
                <!--                  <button-->
                <!--                    class=""-->
                <!--                    nz-button-->
                <!--                    nzType="text"-->
                <!--                    nzDanger nz-popconfirm-->
                <!--                    nzPopconfirmTitle="Are you sure you want to delete the Damage Record"-->
                <!--                    nzPopconfirmPlacement="bottom"-->
                <!--                    (nzOnConfirm)="deleteDamage(i)"-->
                <!--                    (nzOnCancel)="cancel()"-->
                <!--                    (click)="$event.stopPropagation()"-->
                <!--                  >-->
                <!--                    <span nz-icon nzType="delete" nzTheme="outline"></span>-->
                <!--                  </button>-->
                <!--                </div>-->

                <button
                  class="outline-button more-dropdown"
                  nz-button
                  nz-dropdown
                  [nzDropdownMenu]="menu"
                  nzPlacement="bottomCenter"
                  (click)="$event.stopPropagation()" ss
                >
                  <span nz-icon nzType="more" nzTheme="outline"></span>
                </button>
                <nz-dropdown-menu #menu="nzDropdownMenu">
                  <ul nz-menu>
                    <li nz-menu-item nz-popconfirm nz-button (click)="editDamage(panel, i)">Edit</li>
                    <li nz-menu-item nz-button nzDanger nz-popconfirm
                        nzPopconfirmTitle="Are you sure you want to delete the Damage Record"
                        nzPopconfirmPlacement="bottom"
                        (nzOnConfirm)="deleteDamage(i)"
                        (nzOnCancel)="cancel()">Delete
                    </li>
                  </ul>
                </nz-dropdown-menu>
              </ng-template>
            </nz-collapse-panel>
          </nz-collapse>
        </div>

      </div>
    </div>
  </nz-card>
</section>

<section id="description" class="mt-8">
  <nz-card>
    <form nz-form [formGroup]="accidentForm">
      <div>
        <nz-form-label class="">Description of Accident</nz-form-label>
        <nz-form-item>
          <nz-form-control>
            <textarea rows="6" nz-input formControlName="description" PlaceHolder="Enter Notes here"></textarea>
          </nz-form-control>
        </nz-form-item>
      </div>
    </form>
  </nz-card>
</section>

<section id="buttons" class="mt-6">
  <nz-card>
    <div class="flex justify-center sm:justify-end">
      <button class="outline-button mr-3" nz-button nzType="default" nz-popconfirm
              nzPopconfirmTitle="Are you sure you want to cancel this record? you will loose all data."
              (nzOnConfirm)="onSubmitCancel()" (nzOnCancel)="cancel()">Cancel
      </button>
      <button nz-button nz-popconfirm
              nzPopconfirmTitle="You cannot edit the details after submitting the record. Are you sure you want to submit the record?"
              (nzOnConfirm)="onSubmitAccidentData()" (nzOnCancel)="cancel()" nzType="primary"
              [disabled]="(accidentForm.invalid || (!detected && !notified) || (markers.length < 1))">
        Save Record
      </button>
    </div>
  </nz-card>
</section>

<nz-modal
  [(nzVisible)]="isVisible"
  [nzTitle]="modalTitle"
  [nzContent]="modalContent"
  [nzFooter]="modalFooter"
  (nzOnCancel)="handleCancel()"
>
  <ng-template #modalTitle>
    <div class="flex justify-between">
      <div>
        <div class="badge" style="background-color: #F06A21">
          <span class="badge-number" *ngIf="modalStatus==='add'">{{ this.markerNumber }}</span>
          <span class="badge-number" *ngIf="modalStatus==='edit'">{{ this.tempNumber }}</span>
        </div>
      </div>
      <!--      add click animation-->
      <div class="flex items-center" style="margin-right:25px; cursor: pointer">
        <img src="assets/img/camera.png" alt="image" class="mr-3" (click)="triggerFileInput()">
        <p style="color:#F06A21" class="font-medium" (click)="triggerFileInput()">Take a Photo</p>
        <input type="file" id="fileInput" (change)="onFileSelected($event)" accept=".pdf,.docx,.jpg,.png" style="display: none;">
      </div>
    </div>
  </ng-template>

  <ng-template #modalContent>
    <div class="mb-2 mt-2">
      <p class="font-medium">Damage Type</p>
      <nz-select nzPlaceHolder="Select" [(ngModel)]="damageType" style="display: block">
        <nz-option nzValue="Scratch" nzLabel="Scratch"></nz-option>
        <nz-option nzValue="Dent" nzLabel="Dent"></nz-option>
        <nz-option nzValue="Broken" nzLabel="Broken"></nz-option>
        <nz-option nzValue="Cracked" nzLabel="Cracked"></nz-option>
        <nz-option nzValue="Missing" nzLabel="Missing"></nz-option>
        <nz-option nzValue="Stain" nzLabel="Stain"></nz-option>
        <nz-option nzValue="Smashed" nzLabel="Smashed"></nz-option>
      </nz-select>
    </div>
    <div class="mb-2">
      <p class="font-medium">Description</p>
      <textarea rows="3" [(ngModel)]="damageDesc" nz-input PlaceHolder="Enter Description"></textarea>
    </div>
    <div class="mb-2">
      <p class="font-medium">Attachments</p>

      <div class="flex flex-col items-center justify-center bg-slate-100 w-full h-32 xl:h-52 py-2">
        <div>
          <nz-upload
            [nzCustomRequest]="damageUpload" [nzShowUploadList]="false" [nzMultiple]="false">
            <button nz-button>
              <span nz-icon nzType="upload"></span>
              Click to Upload
            </button>
          </nz-upload>
        </div>
        <div>
          <p *ngIf="damageImgUploading" class="text-primary my-2">Uploading...</p>
        </div>
        <div class="mt-2 overflow-auto">
          <div *ngFor="let file of damageFiles; let i = index"
               class="flex justify-between items-center mx-3 gap-5">
            <a target="_blank" href="{{file.url}}">{{ file.name }}</a>
            <span nz-icon nzType="close-circle" nzTheme="outline" [nzTheme]="'twotone'" [nzTwotoneColor]="'#ff0000'"
                  class="cursor-pointer" nz-popconfirm
                  nzPopconfirmTitle="Are you sure you want to delete this attachment"
                  (nzOnConfirm)="removeDamageAttachment(i)"
            ></span>
          </div>
        </div>
      </div>

      <!--      <nz-upload [nzCustomRequest]="damageUpload" [nzShowUploadList]="false" [nzMultiple]="false"-->
      <!--                 class="flex justify-center items-center bg-slate-100 w-full h-32 xl:h-48">-->
      <!--        <button nz-button>-->
      <!--          <span nz-icon nzType="upload"></span>-->
      <!--          Click to Upload-->
      <!--        </button>-->
      <!--      </nz-upload>-->
      <!--      <div *ngIf="damageImgUploading" class="flex justify-center items-center">-->
      <!--        <p class="text-primary">Uploading...</p>-->
      <!--      </div>-->
      <!--      <div *ngFor="let file of damageFiles; let i=index">-->
      <!--        <a class="" target="_blank" href="{{file.url}}">{{file.name}} <span nz-icon nzType="close" nz-popconfirm-->
      <!--                                                                            nzPopconfirmTitle="Are you sure you want to delete the attachment"-->
      <!--                                                                            nzPopconfirmPlacement="bottom"-->
      <!--                                                                            (nzOnConfirm)="confirmRemoveAttachment(i)"-->
      <!--                                                                            (nzOnCancel)="cancel()"-->
      <!--                                                                            nzTheme="outline"></span></a>-->
      <!--      </div>-->
    </div>
  </ng-template>

  <ng-template #modalFooter>
    <button nz-button class="outline-button" nzType="default" (click)="handleCancel()">Cancel</button>
    <button nz-button nzType="primary" [disabled]="this.damageDesc==='' || this.damageType==='' || damageImgUploading"
            *ngIf="this.modalStatus === 'add'" (click)="handleOk(this.tempMouseEvent)">Save
    </button>
    <button nz-button nzType="primary" [disabled]="this.damageDesc==='' || this.damageType==='' || damageImgUploading"
            *ngIf="this.modalStatus === 'edit'" (click)="updateDamage()">Update
    </button>
  </ng-template>
</nz-modal>
